import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserSideBar from "./userSideBar";
import BouncingBallsBackground from "./BouncingBallsBackground";
import "./news.css";

const News = () => {
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState("");
  const query = "Technology";
  const apiKey = "0fb7b7afd77dd1e62ed11f1c339dc57a";
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const accessToken = params.get("token");
        const usernameParam = params.get("username");

        if (accessToken) {
            localStorage.setItem("access_token", accessToken);
            if (usernameParam) {
                localStorage.setItem("username", usernameParam);
                setUsername(usernameParam);
            }
            // Remove token from URL
            window.history.replaceState({}, document.title, "/user");
        } 
        // Else if we don't have a token stored, redirect to login
        else if (!localStorage.getItem("access_token")) {
            alert("You are not logged in. Redirecting to login...");
            navigate("/");
        } 
        // Otherwise, fetch the username from localStorage
        else {
            setUsername(localStorage.getItem("username") || "User");
        }
    }, [navigate]);

  useEffect(() => {
    const fetchGoogleNews = async () => {
      try {
        const response = await fetch(
          `https://gnews.io/api/v4/search?q=${encodeURIComponent(query)}&lang=en&country=us&max=10&apikey=${apiKey}`
        );

        if (!response.ok) {
          throw new Error(
            `Network response was not ok. Status: ${response.status}`
          );
        }

        const data = await response.json();
        setArticles(data.articles || []);
      } catch (error) {
        setError(error.message);
        console.error("Error fetching Google News:", error);
      }
    };

    fetchGoogleNews();
  }, [query, apiKey]);

  return (
    <>
    <BouncingBallsBackground />
    <div className="news-container">
        <UserSideBar />
      <h1>Top Tech News Today</h1>

      {/* Show any fetching error here */}
      {error && <p className="error-message">Error: {error}</p>}

      <div className="news-articles">
        {articles.map((article, index) => (
          <div className="news-article" key={index}>
            {article.image && (
              <img
                className="article-image"
                src={article.image}
                alt={article.title}
              />
            )}
            <div className="article-content">
              <h2>{article.title}</h2>
              <p className="article-des">{article.description}</p>
              <a
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="read-more"
              >
                Read More
              </a>
              <p className="article-source">Source: {article.source.name}</p>
              <p className="article-published">
                Published at: {new Date(article.publishedAt).toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default News;
